'use es6';
export const colors = {
    gray: "#C2C2C2",
    aqua: "#3BC6BE",
    green: "#A2F5A2",
    yellow: "#FFF2AC",
    orange: "#FFAE64",
    red: "#FE7676"
}